import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ref, onMounted } from 'vue'

type Props = {
  src: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SvgDisplay',
  props: {
    src: {}
  },
  setup(__props: any) {

const props = __props

const svgContent = ref<string | null>(null)

onMounted(async () => {
  try {
    const svgPath = require(`@/design-system/assets/icons/${props.src}.svg`)
    const response = await fetch(svgPath)
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    svgContent.value = await response.text()
  } catch (error) {
    svgContent.value = ''
    console.error('There was a problem fetching the SVG:', error)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { innerHTML: svgContent.value }, null, 8, _hoisted_1))
}
}

})